import Vue, { CreateElement, RenderContext, VNode } from "vue";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";

interface Props {
  size: string;
  src: string;
  alt?: string;
  remove: boolean;
  loading: boolean;
}
export default Vue.extend<Props>({
  name: "ImagePreview",
  functional: true,
  props: {
    size: {
      type: String,
      default: "122px",
    },
    src: {
      required: true,
      type: String,
    },
    alt: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    remove: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode | VNode[] {
    const { remove, size, ...imageProps } = ctx.props;

    const Spinner = () => {
      return h("div", { staticClass: "media-preview__preload-wrapper thumbnail-upload-infinite" }, [h(BaseSpinner)]);
    };

    return ctx.props.loading
      ? Spinner()
      : h(
          BaseImage,
          {
            style: {
              width: size,
              height: size,
            },
            staticClass: "image-preview " + ctx.data.staticClass,
            class: ctx.data.class,
            props: {
              topRightIcon: remove,
              bottomLeftIcon: !!ctx.scopedSlots.bottomLeftIcon,
              lazyLoading: false,
              ...imageProps,
            },
            directives: ctx.data.directives,
            on: {
              "click": ctx.listeners.click,
              "click:top-right": ctx.listeners.remove,
            },
            scopedSlots: {
              "bottom-left": () => ctx.scopedSlots.bottomLeftIcon({}),
            },
          },
          []
        );
  },
});
